export default __webpack_public_path__ + "static/media/shooting.c7a517f8.svg";